import React from "react";
import { csvTableStyle } from "./style";
import moment from "moment-timezone";
import { headerCsv } from "@utils/constant";
import { formatAustralianCurrency } from "@utils/commonFunctions";

const CsvTable = ({ csvData = [], totals = {} }) => {
  const classes = csvTableStyle();
  const headers = headerCsv.newLayout;

  return (
    <table className={classes.csvTable}>
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index} className={classes.tableHeader}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {csvData.map((row, i) => (
          <tr key={i}>
            {headers.map((header, j) => {
              let cellValue =
                row[header] || row[header.toLowerCase()] || row[j] || "";

              // Format date
              if (header === "Date" && cellValue) {
                const m = moment(cellValue);
                cellValue = m.isValid() ? m.format("DD/MM/YYYY") : cellValue;
              }

              // Currency columns with negative check
              const currencyHeaders = [
                "JobBasePrice",
                "FuelSurcharge",
                "preloadCharge",
                "Preload Charge",
                "Net",
                "Tax",
                "Gross",
              ];

              if (currencyHeaders.includes(header) && cellValue !== "") {
                const numericValue = Number(cellValue); // convert before formatting
                const formattedValue = formatAustralianCurrency(numericValue);
                const isNegative = numericValue < 0;

                return (
                  <td
                    key={j}
                    className={classes.tableCell}
                    style={{ textAlign: "center", ...(isNegative ? { color: "red" } : {}) }}
                  >
                    {formattedValue}
                  </td>
                );
              }

              return (
                <td key={j} className={classes.tableCell}>
                  {cellValue}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>

      {totals && (totals.totalNet || totals.totalTax || totals.totalGross) && (
        <tfoot>
          <tr>
            {(() => {
              const netIndex = headers.findIndex(h => h.toLowerCase() === "net");
              const taxIndex = headers.findIndex(h => h.toLowerCase() === "tax");
              const grossIndex = headers.findIndex(h => h.toLowerCase() === "gross");

              return (
                <>
                  {/* Label spans all columns before Net */}
                  <td
                    colSpan={netIndex}
                    className={classes.tableCell}
                    style={{ textAlign: "right", fontWeight: "bold" }}
                  >
                    Total Invoice:
                  </td>

                  {/* Format Net, Tax, and Gross columns */}
                  {headers.map((_, idx) => {
                    if ([netIndex, taxIndex, grossIndex].includes(idx)) {
                      let value =
                        idx === netIndex
                          ? totals.totalNet
                          : idx === taxIndex
                            ? totals.totalTax
                            : totals.totalGross;

                      const numericValue = Number(value);
                      const formattedValue = formatAustralianCurrency(numericValue);
                      const isNegative = numericValue < 0;

                      return (
                        <td
                          key={idx}
                          className={classes.tableCell}
                          style={{
                            textAlign: "right",
                            fontWeight: "bold",
                            color: isNegative ? "red" : "inherit",
                          }}
                        >
                          {formattedValue}
                        </td>
                      );
                    }
                    return null;
                  })}
                </>
              );
            })()}
          </tr>
        </tfoot>
      )}
    </table>
  );
};

export default CsvTable;
